import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetch TAT (Turnaround Time) list with pagination
 * @param {Object} params
 * @param {number} params.pageNumber - Page number (default: 1)
 * @param {number} params.pageSize - Page size (default: 10)
 * @returns {Promise<{success: boolean, data?: Array, totalCount?: number, pageNumber?: number, pageSize?: number, message?: string, error?: any}>}
 */
export const fetchTatListAction = async ({ pageNumber = 1, pageSize = 10 }) => {
  try {
    const response = await apiClient.get(ATP_API_URL.TAT_LIST, {
      params: {
        pageNumber,
        pageSize,
      },
    });

    console.log("[TATList] API response:", response?.data);

    if (response?.status === 200 && response.data) {
      const { success, data, totalCount, message } = response.data;

      if (success) {
        return {
          success: true,
          data: data || [],
          totalCount: totalCount || 0,
          pageNumber: response.data.pageNumber || pageNumber,
          pageSize: response.data.pageSize || pageSize,
          message: message || "TAT list fetched successfully",
        };
      }
    }

    return {
      success: false,
      message: "Failed to fetch TAT list",
      data: [],
      totalCount: 0,
    };
  } catch (error) {
    console.error("[TATList] error:", error);
    return {
      success: false,
      message: error.message || "Failed to fetch TAT list",
      error,
      data: [],
      totalCount: 0,
    };
  }
};
